import classNames from 'classnames';
import React, { forwardRef } from 'react';
import LoadingSpinner from '../internal/LoadingSpinner.js';
import { BaseButton } from './BaseButton.js';

/**
 * A loading button component that shows a loading indicator when the loading prop is true.
 * When loading, the button is automatically disabled and shows a spinner.
 * Supports all BaseButton props including prefix and suffix.
 *
 * @component
 */
const LoadingButton = forwardRef(({ loading = false, loadingAriaLabel = "Loading...", className, label, prefix, suffix, ...restProps }, ref) => {
    return (React.createElement(BaseButton, { ...restProps, ref: ref, className: classNames(className, { "tds-btn--loading": loading }), "aria-disabled": loading, disabled: loading, "aria-label": loading ? loadingAriaLabel : undefined, "aria-busy": loading, label: React.createElement(React.Fragment, null,
            React.createElement(LoadingSpinner, null),
            prefix && React.createElement("span", { className: "prefix" }, prefix),
            React.createElement("span", null, label),
            suffix && React.createElement("span", { className: "suffix" }, suffix)) }));
});
LoadingButton.displayName = "LoadingButton";

export { LoadingButton };
//# sourceMappingURL=LoadingButton.js.map
